import { getToken } from './token';

const BASE_URL = import.meta.env.VITE_API_URL ?? '/api';

export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

function authHeader(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function fail(res: Response): Promise<never> {
  const text = await res.text();
  let message = `Request failed: ${res.status}`;
  try {
    const data: unknown = text ? JSON.parse(text) : null;
    if (typeof data === 'object' && data !== null && 'error' in data) {
      message = String((data as { error: unknown }).error);
    }
  } catch {
  }
  throw new ApiError(message, res.status);
}

export async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      ...init.headers,
    },
  });

  if (!res.ok) return fail(res);

  const text = await res.text();
  return (text ? JSON.parse(text) : null) as T;
}

export async function upload<T>(
  path: string,
  body: FormData,
  method: 'POST' | 'PATCH' | 'PUT' = 'POST',
): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    body,
    headers: authHeader(),
  });

  if (!res.ok) return fail(res);
  return (await res.json()) as T;
}

export async function download(path: string): Promise<Blob> {
  const res = await fetch(`${BASE_URL}${path}`, { headers: authHeader() });
  if (!res.ok) return fail(res);
  return res.blob();
}
